import auth from "../../middlewares/auth";
export const settingsThinkingAreaRoute = [
  {
    path: '/settings/thinking_area',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/thinking_area/ThinkingAreaList'),
    name: 'settings_thinking_area',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/thinking_area/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/thinking_area/ThinkingAreaForm'),
    name: 'settings_thinking_area_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/thinking_area/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/thinking_area/ThinkingAreaForm'),
    name: 'settings_thinking_area_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];